export const getContentAPIOptionsFromDate = selectedDay => ({
  locale: `ops/${selectedDay.year}`,
  applicationName: `${selectedDay.month}`,
  folder: `${selectedDay.day}`,
  baseLocation: "data",
  ignoreCache: true,
  loc: `ops/${selectedDay.year}/${selectedDay.month}/${selectedDay.day}`
});
export const phoneNumberIsInternationalFormat = (inputValue, dialCodes) => {
  if (inputValue[0] !== "+") {
    return false;
  }
  let dialCode = "";
  dialCodes.forEach(dc => {
    if (inputValue.includes(`+${dc.dialCode}`)) {
      dialCode = `+${dc === null || dc === void 0 ? void 0 : dc.dialCode}`;
    }
  });
  if (dialCode === "") {
    return false;
  }
  const splitOnDialcode = inputValue.split(dialCode);
  if (splitOnDialcode.length !== 2) {
    return false;
  }
  if (splitOnDialcode[1][0] === "0" && splitOnDialcode[1][1] === "0") {
    return false;
  }
  let trimmedInput = inputValue.substring(1, inputValue.length).trim();
  if (/\s/g.test(trimmedInput) || /-/g.test(trimmedInput)) {
    return false;
  }
  trimmedInput = trimmedInput.replace(/\s/g, "");
  if (trimmedInput.length < 9 || trimmedInput.length > 16) {
    return false;
  }
  return /^\d+$/.test(trimmedInput);
};
export const getPhoneNumberInInternationalFormat = primaryContactNumber => {
  let final = primaryContactNumber;
  if (final) {
    const items = primaryContactNumber.split("-");
    if (items.length >= 2) {
      if (items[1].indexOf("0") === 0) {
        items[1] = items[1].substring(1, items[1].length);
      }
      final = items.join("");
    }
    if (final[0] !== "+") {
      final = `+${final}`;
    }
    final = final.replace(/\s/g, "");
  }
  return final;
};
export const isNumeric = val => {
  if (typeof val !== "undefined") {
    return /^\d+$/.test(val);
  }
  return false;
};
export const parseMfaDialCodeAndPhone = (phoneNumber, dialCodes) => {
  let value = {};
  dialCodes.forEach(item => {
    const dialCodeString = `+${item.dialCode}`;
    if (phoneNumber.includes(dialCodeString)) {
      value = {
        dialCodeValue: `${item.countryDescription} (+${item.dialCode})`,
        phoneNumberValue: phoneNumber.substring(dialCodeString.length)
      };
    } else if (phoneNumber.split("-")[0] === item.dialCode.toString()) {
      value = {
        dialCodeValue: `${item.countryDescription} (+${item.dialCode})`,
        phoneNumberValue: phoneNumber.split("-")[1]
      };
    }
  });
  return value;
};
export const getMfaDialCodeDropdownOptions = dialCodes => dialCodes.map(item => `${item.countryDescription} (+${item.dialCode})`).sort((a, b) => a < b ? -1 : a > b ? 1 : 0);
export const parseDialCodeInputValue = value => {
  var _value$split$;
  return value === null || value === void 0 ? void 0 : (_value$split$ = value.split("(")[1]) === null || _value$split$ === void 0 ? void 0 : _value$split$.slice(0, -1);
};
export const getParseMfaPhoneNumber = (phoneNumber, dialCodes) => {
  let value = phoneNumber;
  dialCodes.forEach(item => {
    const dialCodeString = `+${item.dialCode}`;
    if (phoneNumber.includes(dialCodeString)) {
      var _phoneNumber$substrin;
      if (((_phoneNumber$substrin = phoneNumber.substring(dialCodeString.length)) === null || _phoneNumber$substrin === void 0 ? void 0 : _phoneNumber$substrin.charAt(0)) === "0") {
        value = dialCodeString + phoneNumber.substring(dialCodeString.length).substring(1);
      }
    }
  });
  return value;
};